module.exports = __webpack_public_path__ + "img/img_02@2x.5494bbea.png";